// extracted by mini-css-extract-plugin
module.exports = {"flightInfo":"FlightInfo_flightInfo__3PAe3","content":"FlightInfo_content__1njFA"};